"use client";

import DuoColorBorder from "@/components/buttons/custom-border/duo-color-border";
import Image from "next/image";
import { useEffect, useState } from "react";
import Loading from "../_partials/loading/loading";
import { getKinds, getType, limitDecimalsToString } from "../util/functions";

const RecentClips = ({
	lastClips,
	type,
	setType,
	trailer,
	showKinds = true,
	mutate,
	isLoading,
}: {
	lastClips: any[];
	type?: string;
	setType?: (type?: string) => void;
	trailer?: any;
	showKinds?: boolean;
	mutate?: any;
	isLoading?: boolean;
}) => {
	const [selectedClip, setSelectedClip] = useState<any>(
		trailer
			? trailer
			: lastClips && lastClips.length > 0
				? lastClips[0]
				: undefined,
	);
	useEffect(() => {
		if (trailer) {
			setSelectedClip(trailer);
		}
	}, [trailer]);

	const [isDrawerOpen, setDrawerOpen] = useState<boolean>(false);

	useEffect(() => {
		if (!selectedClip && lastClips && lastClips.length > 0) {
			setSelectedClip(lastClips[0]);
		}
	}, [lastClips, selectedClip]);

	useEffect(() => {
		if (showKinds && type && setType) {
			const query = new URLSearchParams();
			type && query.append("type", type);
			const qs = query.toString();
			const newUrl = qs
				? `${window.location.pathname}?${qs}`
				: window.location.pathname;

			window.history.replaceState(null, "", newUrl);
			setType(type);
		}
	}, [type, showKinds, mutate]);

	return (
		<div className="flex flex-col lg:flex-row-reverse gap-6 overflow-hidden">
			<button
				className="bg-light-lime text-black px-4 py-2 rounded lg:hidden"
				onClick={() => setDrawerOpen(true)}
			>
				نمایش لیست
			</button>

			{isDrawerOpen && (
				<div
					className="fixed inset-0 bg-black bg-opacity-50 z-30"
					onClick={() => setDrawerOpen(false)}
				></div>
			)}

			<aside
				className={`fixed h-full top-[67px] md:top-0 lg:relative w-[320px] bg-black text-white transition-transform ${
					isDrawerOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
				} lg:w-[400px] overflow-auto z-50 lg:z-auto top-0 left-0 shadow-lg`}
			>
				{showKinds && (
					<div className="flex gap-2 mb-4 p-4 sticky top-0 z-20 bg-black">
						<button
							onClick={() => setType && setType(undefined)}
							className={`px-3 py-1 rounded-lg transition-all text-[10px] md:text-sm ${
								type === undefined
									? "bg-gradient-to-r from-[#2CC2F9] to-[#A9F958] text-black"
									: "bg-white/20 text-white"
							}`}
						>
							همه
						</button>
						{getKinds().map((tab, index) => (
							<button
								key={index}
								onClick={() => setType && setType(tab.type)}
								className={`px-3 py-1 rounded-lg transition-all text-[10px] md:text-sm ${
									type === tab.type
										? "bg-gradient-to-r from-[#2CC2F9] to-[#A9F958] text-black"
										: "bg-white/20 text-white"
								}`}
							>
								{tab.name}
							</button>
						))}
					</div>
				)}
				<ul className="space-y-2 overflow-y-auto pr-2">
					{trailer && (
						<li
							key={trailer?.id}
							className="flex items-center h-[95px] rounded-md p-2 hover:bg-gray-700 cursor-pointer"
							onClick={() => {
								setSelectedClip(trailer);
								setDrawerOpen(false);
							}}
						>
							<div className="relative min-w-[100px] h-[80px]">
								<Image
									src={
										process.env.NEXT_PUBLIC_FILE_URL +
										trailer?.bannerImage?.code
									}
									alt={trailer?.title}
									fill
									className="object-cover rounded"
								/>
							</div>
							<div className="flex flex-col justify-start h-full gap-1 px-3 py-2">
								<h4 className="text-sm font-bold">{trailer?.title}</h4>
								<p className="text-xs text-gray-400">
									{getType(trailer?.content?._class)?.name}
								</p>
								<p className="text-xs text-gray-400 flex gap-2">
									<span>
										{limitDecimalsToString(trailer?.cutinScore, 1) ?? 0}/10
									</span>
									<span>.</span>
									<span>بر اساس {trailer?.totalScore ?? 0} نظر</span>
								</p>
							</div>
						</li>
					)}
					{isLoading && <Loading />}
					{!isLoading &&
						lastClips.map((clip) => (
							<li
								key={clip.id}
								className="flex items-center h-[95px] rounded-md p-2 hover:bg-gray-700 cursor-pointer"
								onClick={() => {
									setSelectedClip(clip);
									setDrawerOpen(false);
								}}
							>
								<div className="relative min-w-[100px] h-[80px]">
									<Image
										src={
											process.env.NEXT_PUBLIC_FILE_URL + clip?.bannerImage?.code
										}
										alt={clip?.title}
										fill
										className="object-cover rounded"
									/>
								</div>
								<div className="flex flex-col justify-start h-full gap-1 px-3 py-2">
									<h4 className="text-sm font-bold">{clip?.title}</h4>
									<p className="text-xs text-gray-400">
										{getType(clip.content._class)?.name}
									</p>
									<p className="text-xs text-gray-400 flex gap-2">
										<span>
											{limitDecimalsToString(clip?.cutinScore, 1) ?? 0}/10
										</span>
										<span>.</span>
										<span>بر اساس {clip.totalScore ?? 0} نظر</span>
									</p>
								</div>
							</li>
						))}
				</ul>
			</aside>

			<section className="flex-1">
				<div className="relative w-full aspect-video mb-6 max-w-[1200px]">
					{selectedClip &&
						selectedClip.videoUrl &&
						(selectedClip.videoUrl.includes("cutin") ? (
							<video
								src={selectedClip.videoUrl}
								title={selectedClip.title}
								controls
							/>
						) : (
							<iframe
								src={selectedClip.videoUrl}
								title={selectedClip.title}
								allowFullScreen
								width="100%"
								height="100%"
							/>
						))}
				</div>
				<div className="flex items-center justify-between mb-2 gap-2.5 md:flex-row flex-col">
					<div className="w-full md:w-[50%]">
						<h3 className="text-sm md:text-2xl font-bold">
							{selectedClip?.title}
						</h3>
						<DuoColorBorder
							id={`recent-clips-${selectedClip?.id}`}
							color="#A9F958"
							secondColor="#FFF"
							extraClasses="w-max px-3 py-2 mt-1"
							direction="to bottom"
						>
							<p className="font-medium text-[8px] md:text-[12px]">
								{getType(selectedClip?.content._class)?.name}
							</p>
						</DuoColorBorder>
					</div>
					<div className="flex w-full md:w-[50%] gap-4 items-center">
						<div>
							<Image src="/cib_imdb.png" alt="cib" width={80} height={64} />
						</div>
						<div className="flex items-start flex-col">
							<div>
								<span className="text-sm md:text-[24px] font-semiBold">
									کات اسکور
								</span>
								<span className="text-xs mr-2 text-white rounded md:text-[16px]">
									10 /
								</span>
								<span className="text-sm text-light-lime font-semiBold rounded md:text-[20px]">
									{limitDecimalsToString(selectedClip?.cutinScore, 1) ?? 0}
								</span>
							</div>
							<span className="text-xs md:text-sm text-gray-400">
								{selectedClip?.totalScore} رأی
							</span>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default RecentClips;
